module.exports = __webpack_public_path__ + "static/img/image035.7c6baf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image035.png
// module id = TeGY
// module chunks = 1